import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26bf7158"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "硬件信息", -1))
const _hoisted_2 = { class: "hardware-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-info-and-arch" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"1px"} }, " Basic Info And Arch")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cpu-info" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"1px"} }, " CPU Info")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "memory-info" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"1px"} }, " Memory Info")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disk-info" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"1px"} }, " Disk Info")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-info" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"1px"} }, " Other Info")
], -1))

import { hardwareAPI } from '@/api/hardware';
import { useRoute } from 'vue-router';
import { Hardware, HardwareState, DiskInfo, WaveinCaps } from '@/store/modules/hardware/types';
import { onMounted, ref, watchEffect, computed } from 'vue';
import changeToDateTime from '@/utils/timestamp2DateTime';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "HardwareWindow",
});



interface TimeLineNode {
    content: number,
    timeToDisplay: string,
    timestamp: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const uid: string = route.params.targetId as string;

const hardwareState = ref<HardwareState>({
    hardwareList: [],
    isLoading: false,
});
const popoverVisible = ref<boolean>(false)
const hardwareDisplay = ref<Hardware>(
    hardwareState.value.hardwareList.length === 0 ? {} as Hardware : hardwareState.value.hardwareList[0]
);
const activeName = ref<string[]>(
)
const timeLineSlice = ref<TimeLineNode[]>([])
const nowTimeNode = ref<string>("")

watchEffect(() => {
    if (hardwareState.value.hardwareList.length !== 0) {
        hardwareDisplay.value = hardwareState.value.hardwareList[0];
    }
})

const getIPList = (ips: string): [] => {
    if (ips === undefined) {
        return []
    } else {
        return JSON.parse(ips)
    }
}

const getHostList = (hosts: string): [] => {
    if (hosts === "" || hosts === undefined) {
        return []
    } else {
        return JSON.parse(hosts)
    }
}

const getWaveInCaps = (datas: string): WaveinCaps[] => {
    if (datas === undefined) {
        return []
    } else {
        let res = []
        let waveinCaps = JSON.parse(datas)
        for (let i = 0; i < waveinCaps.length; i++) {
            res.push({
                Manufacturer: waveinCaps[i].Manufacturer,
                ProductId: waveinCaps[i].ProductId,
                DriverVersion: waveinCaps[i].DriverVersion,
                Formats: waveinCaps[i].Formats,
                Channels: waveinCaps[i].Channels,
                MinSampleRate: waveinCaps[i].MinSampleRate,
                MaxSampleRate: waveinCaps[i].MaxSampleRate,
                ProductNameUtf8: waveinCaps[i].ProductNameUtf8,
            })
        }
        return res
    }
}


const getDiskInfo = (data: string): DiskInfo[] => {
    if (data === undefined) {
        return []
    } else {
        let disks: DiskInfo[] = JSON.parse(data)
        for (let i = 0; i < disks.length; i++) {
            disks[i].used = disks[i].total - disks[i].free
            disks[i].usage = Math.trunc(disks[i].used / disks[i].total * 100) + '%'
        }
        return disks
    }
}

const changeToTime = (time: number): string => {
    const d = Math.trunc(Math.trunc(time / 60 / 60) / 24);

    let h = String(Math.trunc(time / 60 / 60) % 24) + 'h ';
    let m = String(Math.trunc(time / 60) % 60) + 'm ';
    let s = String(time % 60) + 's';
    return d + (d <= 1 ? 'day ' : 'days ') + h + m + s;
}

const b2GB = (b: number): string => {
    return (b / 1024 / 1024 / 1024).toFixed(1) + 'GB'
}

const getTimeLine = () => {
    for (let i = 0; i < hardwareState.value.hardwareList.length; i++) {
        timeLineSlice.value.push({
            content: hardwareState.value.hardwareList[i].id,
            timeToDisplay: getDisplayTime(hardwareState.value.hardwareList[i].created),
            timestamp: hardwareState.value.hardwareList[i].created
        })
    }
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleChooseTime = async (date: string, id: number) => {
    popoverVisible.value = false
    hardwareState.value.isLoading = true
    nowTimeNode.value = date

    try {
        hardwareState.value.hardwareList = await hardwareAPI.getOneComputerInfoListByUidAndTime(projectId.value, uid, id);
    } catch (err) {
        hardwareState.value.hardwareList = [];
    } finally {
        hardwareState.value.isLoading = false
    }

}


onMounted(async () => {
    activeName.value === undefined ? activeName.value = ['basic-info-and-arch'] : activeName.value.push('basic-info-and-arch')

    hardwareState.value.isLoading = true
    try {
        const projId = projectId.value
        hardwareState.value.hardwareList = await hardwareAPI.getHardwareListByUid(projId, uid);
        getTimeLine()
        nowTimeNode.value = hardwareState.value.hardwareList[0].created

    } catch (err) {
        hardwareState.value.hardwareList = [];
    } finally {
        hardwareState.value.isLoading = false
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_timeline, { class: "TimeLinePopover" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineSlice.value, (timeNode, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: timeNode.timeToDisplay,
                  onClick: ($event: any) => (handleChooseTime(timeNode.timestamp, timeNode.content)),
                  type: timeNode.timestamp === nowTimeNode.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(timeNode.timeToDisplay), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp", "onClick", "type"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (hardwareState.value.hardwareList.length !== 0)
        ? (_openBlock(), _createBlock(_component_el_collapse, {
            key: 0,
            class: "description-hardware",
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, { name: "basic-info-and-arch" }, {
                title: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    direction: "horizontal",
                    column: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: "HostName",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.hostname), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "UserName",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.UserName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "UpTime",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(changeToTime(hardwareDisplay.value.uptime)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "BootTime",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(changeToDateTime)(hardwareDisplay.value.bootTime)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "OS",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.os), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "Platform",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.platform), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "PlatformFamily",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.platformFamily), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "PlatformVersion",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.platformVersion), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "KernelVersion",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.kernelVersion), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "KernelArch",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.kernelArch), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "VirtualizationSystem",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.virtualizationSystem), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "VirtualizationRole",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.virtualizationRole), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "HostId",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.hostId), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "Mac",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.Mac), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "ScreenResolution",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.ResolutionWidth + ' × ' + hardwareDisplay.value.ResolutionHeight), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "CPU Info",
                name: "cpu-info"
              }, {
                title: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    direction: "horizontal",
                    column: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: "CPUModel",
                        span: 2,
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.CPUModel), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "CPUCoresLogical",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.CPUCoresLogical), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "CPUCoresPhysical",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.CPUCoresPhysical), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "Memory Info",
                name: "memory-info"
              }, {
                title: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    direction: "horizontal",
                    column: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: "MemoryFree",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(b2GB(hardwareDisplay.value.MemoryFree)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "MemoryTotal",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(b2GB(hardwareDisplay.value.MemoryTotal)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "MemoryUsed",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(b2GB(hardwareDisplay.value.MemoryUsed)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "MemoryUsage",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.MemoryUsage) + "% ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "Disk Info",
                name: "disk-info"
              }, {
                title: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    direction: "horizontal",
                    column: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDiskInfo(hardwareDisplay.value.Diskusage), (disk, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createVNode(_component_el_descriptions_item, {
                            label: "Drive Letter",
                            align: "center",
                            width: "25%"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(disk.path), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, {
                            label: "Used/Total/Usage",
                            align: "center",
                            width: "25%"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(b2GB(disk.used)) + "/" + _toDisplayString(b2GB(disk.total)) + "/" + _toDisplayString(disk.usage), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_collapse_item, {
                title: "Other Info",
                name: "other-info"
              }, {
                title: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    direction: "horizontal",
                    column: 2,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: "IP",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getIPList(hardwareDisplay.value.IP), (ip) => {
                            return (_openBlock(), _createElementBlock("li", { key: ip }, _toDisplayString(ip), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "Export IP",
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(hardwareDisplay.value.RealIp), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "WaveInCaps",
                        span: 2,
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWaveInCaps(hardwareDisplay.value.WaveInCaps), (wave, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(wave), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, {
                        label: "Hosts",
                        span: 2,
                        align: "center",
                        width: "25%"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getHostList(hardwareDisplay.value.Hosts), (line, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: index,
                              style: {"white-space":"pre","margin-left":"30px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(line), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "description",
            class: "description-hardware"
          }))
    ])), [
      [_directive_loading, hardwareState.value.isLoading]
    ])
  ], 64))
}
}

})